import {
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { parseEntityRef } from '@backstage/catalog-model';
import {
  ReadEvent,
  ReadEventClient,
} from '@internal/plugin-neo4j-techdocs-common';
import useAsync from 'react-use/esm/useAsync';

type useLastReadEventType = {
  value: ReadEvent | undefined;
  loading: boolean;
  error: Error | undefined;
};

export const useUserLastReadEvent = (
  docEntityRef: string,
  dependencies: any[] = [],
): useLastReadEventType => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef);
  const readClient = new ReadEventClient({ discoveryApi, fetchApi });
  const {
    loading,
    error,
    value: readEvent,
  } = useAsync(async () => {
    const identity = await identityApi.getBackstageIdentity();
    const username = parseEntityRef(identity.userEntityRef).name;
    const getReadEventsResponse = await readClient.userGet({
      path: { user: username },
      query: {
        docEntityRefFilter: [docEntityRef],
        limit: 1,
      },
    });
    if (getReadEventsResponse.ok) {
      const readEvents = await getReadEventsResponse.json();
      if (readEvents.length > 0) {
        return readEvents[0];
      }
      return undefined;
    }
    throw new Error(
      `Failed to get query read events: ${getReadEventsResponse.statusText}`,
    );
  }, dependencies);
  return {
    value: readEvent,
    loading,
    error,
  };
};
